import React, { useState } from 'react';
import { Box, Paper, Grid, Stack, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ImUserTie } from 'react-icons/im';
import '../../App.css';
import Popup from '../Popup';
import EmployeeRolesTable from '../table-data/EmployeeRolesTable';
import EmployeeRoleForm from './EmployeeRoleForm';

function ViewEmployeeRoles() {
  const [openPopup, setOpenPopup] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const handleAddClick = () => {
    setEditingRole(null);
    setOpenPopup(true);
  };

  const handleEdit = (role) => {
    setEditingRole(role);
    setOpenPopup(true);
  };

  const handleSuccess = () => {
    setOpenPopup(false);
    setReloadKey((prev) => prev + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        padding: '30px',
        fontWeight: '500px',
      }}
    >
      <Paper elevation={0} sx={{ width: '600px' }}>
        <Grid className="form-title" style={{ marginBottom: '-60px'}} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              Employee Roles
            </Typography>
          </Grid>
          <Grid item>
            <ImUserTie style={{ marginLeft: '-30px' }} size={40} color="#344D67" />
          </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '30px' }} style={{ marginLeft: '51px' }}>
            <Stack display="flex" sx={{ alignItems: 'flex-end' }}>
              <Button
                style={{ width: '160px', marginRight: '32px',marginBottom: '-10px',marginTop: '10px' }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={handleAddClick}
                startIcon={<Add sx={{ width: 24, height: 24 }} style={{ marginRight: '-8px' }} />}
                sx={{
                  whiteSpace: 'nowrap',
                  textTransform: 'none',
                }}
              >
              Add Employee Role
              </Button>
            </Stack>

            <EmployeeRolesTable onEdit={handleEdit} reloadKey={reloadKey} />
          </Stack>
        </form>

        <Popup
          title={editingRole ? 'Edit Employee Role' : 'Add Employee Role'}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <EmployeeRoleForm initialData={editingRole} onSuccess={handleSuccess} />
        </Popup>
      </Paper>
    </Box>
  );
}

export default ViewEmployeeRoles;

